(function () {
  if (window.fsSubscriptionSectionCartInitialized) return;
  window.fsSubscriptionSectionCartInitialized = true;

  var BUTTON_SELECTOR = '[data-subscription-add]';
  var SELECT_SELECTOR = '[data-subscription-select]';

  function setError(button, message) {
    var error = button.parentElement && button.parentElement.querySelector('.subscription-card__error');
    if (!error) return;

    error.textContent = message || '';
    error.hidden = !message;
  }

  function setLoading(button, loading) {
    button.classList.toggle('loading', loading);
    button.setAttribute('aria-disabled', loading ? 'true' : 'false');

    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  function getCartSurface() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function appendCartSections(formData, cart) {
    if (!cart || typeof cart.getSectionsToRender !== 'function') return;

    formData.append(
      'sections',
      cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);
  }

  function publishCartUpdate(variantId, response) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'homepage-subscription',
      productVariantId: variantId,
      cartData: response,
    });
  }

  function publishCartError(variantId, response) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartError, {
      source: 'homepage-subscription',
      productVariantId: variantId,
      errors: response.errors || response.description,
      message: response.message,
    });
  }

  function addSubscription(button) {
    if (button.disabled || button.classList.contains('loading')) return;

    var purchase = button.closest('.subscription-card__purchase');
    var primarySelect = purchase && purchase.querySelector(SELECT_SELECTOR + '[data-subscription-select="primary"]');
    var secondarySelect = purchase && purchase.querySelector(SELECT_SELECTOR + '[data-subscription-select="secondary"]');
    var primaryOption = primarySelect && primarySelect.options[primarySelect.selectedIndex];
    var secondaryOption = secondarySelect && secondarySelect.options[secondarySelect.selectedIndex];
    var variantId = primaryOption && primaryOption.dataset.variantId;
    var sellingPlanId = primaryOption && primaryOption.dataset.sellingPlanId;
    var primaryScent = primaryOption && primaryOption.dataset.scentTitle;
    var secondaryScent = secondaryOption && secondaryOption.dataset.scentTitle;
    var subscriptionTitle = button.dataset.subscriptionTitle || '';

    if (!variantId || !sellingPlanId || !subscriptionTitle || !primaryScent || !secondaryScent) {
      setError(button, 'Please select both refill scents.');
      return;
    }

    var cart = getCartSurface();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('selling_plan', sellingPlanId);
    formData.append('properties[Subscription Type]', subscriptionTitle);
    formData.append('properties[Refill scent 1]', primaryScent);
    formData.append('properties[Refill scent 2]', secondaryScent);
    formData.append('properties[Selected Scents]', primaryScent + ', ' + secondaryScent);
    formData.append('properties[_subscription_compare_at_cents]', button.dataset.compareAtCents || '');
    formData.append('properties[_subscription_savings_cents]', button.dataset.savingsCents || '');
    appendCartSections(formData, cart);

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    setError(button, '');
    setLoading(button, true);
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          publishCartError(variantId, response);
          throw new Error(response.description || response.message || 'Unable to add this subscription.');
        }

        publishCartUpdate(variantId, response);

        if (cart && typeof cart.renderContents === 'function' && response.sections) {
          cart.renderContents(response);
        } else {
          window.location.assign(window.routes.cart_url);
        }
      })
      .catch(function (error) {
        setError(button, error.message || 'Unable to add this subscription. Please try again.');
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    addSubscription(button);
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target.closest(SELECT_SELECTOR);
    if (!select) return;

    var purchase = select.closest('.subscription-card__purchase');
    var button = purchase && purchase.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    if (select.dataset.subscriptionSelect === 'primary') {
      var option = select.options[select.selectedIndex];
      button.dataset.variantId = option ? option.dataset.variantId || '' : '';
      button.dataset.sellingPlanId = option ? option.dataset.sellingPlanId || '' : '';
    }

    setError(button, '');
  });
})();
